import React from "react";
import "components/General/Form/Form.css";

const CustomInput = (props) => {
  return props.orientation === "labeled" ? (
    <div className="form-group">
      <table>
        <tbody>
          <tr>
            <td style={{ width: "25%", textAlign:"left" }}>{props.label}{props.required?("*"):("")}</td>
            <td style={{ width: "75%" }}>
              <input
                name={props.name}
                type={props.type}
                className={`form-control ${props.error ? "is-invalid" : ""} ${
                  props.className
                } custom_input`}
                id={props.name}
                placeholder={props.placeholder}
                value={props.value}
                onChange={props.handleChange}
                onBlur={props.handleBlur}
                readOnly={props.readOnly ? "readOnly" : false}
              />
            </td>
          </tr>
          {props.error ? (<tr>
            <td style={{ width: "25%" }}/>
            <td>
              <div className="invalid-feedback" style={{ display: "block", textAlign:"left" }}>
                {props.error}
              </div>
            </td>
          </tr>):(<tr/>)}
        </tbody>
      </table>
    </div>
  ) : (
    <div className="form-group">
      <input
        name={props.name}
        type={props.type}
        className={`form-control ${props.error ? "is-invalid" : ""} ${
          props.className
        } custom_input`}
        id={props.name}
        placeholder={props.placeholder}
        value={props.value}
        onChange={props.handleChange}
        onBlur={props.handleBlur}
        readOnly={props.readOnly ? "readOnly" : false}
      />
      <div className="invalid-feedback">{props.error}</div>
    </div>
  );
};

export default CustomInput;
